export enum TutoringFormModalStep {
  subjectDetails = "subjectDetails",
  additionalInfo = "additionalInfo",
  confirmation = "confirmation",
  tutoringType = "tutoringType"
}

export const TutoringFormModalOrder = [
  TutoringFormModalStep.subjectDetails,
  TutoringFormModalStep.additionalInfo,
  TutoringFormModalStep.confirmation
];
